import { render } from "./MyProfileLanguageBox.vue?vue&type=template&id=8ad8bbd2"
import script from "./MyProfileLanguageBox.vue?vue&type=script&lang=js"
export * from "./MyProfileLanguageBox.vue?vue&type=script&lang=js"

import "./MyProfileLanguageBox.vue?vue&type=style&index=0&id=8ad8bbd2&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__